/**
 * Les routes poussées du lot Jeu : celles qu'il fait passer sur le design system.
 *
 * Pontées par le socle : `skill-set` (« Mes quêtes », la liste — l'ancien `MySkillSetsTabScreen`),
 * `skill-sets` (le détail d'une quête, `?skillSetId=` — l'ancien `MyProgressScreen` ; les deux noms
 * sont ceux de l'ancien code, à l'envers de ce qu'ils disent), `ranking`, et `shop` et `petals` (le
 * même écran legacy sous deux noms : les deux sont inscrits). Une route inscrite ici rend l'écran des
 * ports pour un élève dont l'espace est allumé, hors espace parent et hors live, et son écran legacy
 * ailleurs.
 *
 * Chaque écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
const StudentShopScreen = loadedOnRender(() => require("./StudentShopScreen").StudentShopScreen, "StudentShopScreen")

export const gameRoutes: StudentSpaceRouteTable<"game"> = {
    "skill-set": loadedOnRender(() => require("./StudentQuestsScreen").StudentQuestsScreen, "StudentQuestsScreen"),
    "skill-sets": loadedOnRender(
        () => require("./StudentQuestDetailScreen").StudentQuestDetailScreen,
        "StudentQuestDetailScreen"
    ),
    ranking: loadedOnRender(() => require("./StudentRankingScreen").StudentRankingScreen, "StudentRankingScreen"),
    shop: StudentShopScreen,
    petals: StudentShopScreen,
}
/* eslint-enable @typescript-eslint/no-require-imports */
